// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
export type NonTrustCharitableEntityDetailsCard_DonorPrincipalFragment = { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string, legalName: string, firstName: string, lastName: string } | null };

export type NonTrustCharitableEntityDetailsCard_ControllingPartyFragment = { __typename?: 'ControllingParty', id: string, individual?: { __typename?: 'ClientProfile', id: string, legalName: string, firstName: string, lastName: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null };

export const Operations = {
  Fragment: {
    NonTrustCharitableEntityDetailsCard_DonorPrincipal: 'NonTrustCharitableEntityDetailsCard_DonorPrincipal' as const,
    NonTrustCharitableEntityDetailsCard_ControllingParty: 'NonTrustCharitableEntityDetailsCard_ControllingParty' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const NonTrustCharitableEntityDetailsCard_DonorPrincipalFragmentDoc = gql`
    fragment NonTrustCharitableEntityDetailsCard_DonorPrincipal on Principal {
  id
  individual {
    id
    legalName
    firstName
    lastName
  }
}
    `;
export const NonTrustCharitableEntityDetailsCard_ControllingPartyFragmentDoc = gql`
    fragment NonTrustCharitableEntityDetailsCard_ControllingParty on ControllingParty {
  id
  individual {
    id
    legalName
    firstName
    lastName
  }
  organization {
    id
    name
  }
}
    `;